import React, { useState } from 'react';
import styled from 'styled-components';
import WhatsappVerificationCode from 'components/shared/VerifyWhatsappCodeComponent';
import { FlexColumn } from 'styles/Layout';
import withWhatsappVerification from 'components/account/withWhatsappVerification';
import ChangeMobilePhoneModal from 'modules/agencies/RgAdvisors/components/ChangeMobilePhoneModalComponent';

const Wrapper = styled.div`
  background-color: #f0ecfc;
  width: 100%;
  height: 141px;
  display: flex;
  align-items: center;
`;
const WrapperContent = styled(FlexColumn)`
  width: 300px;
  margin: 0 auto;
`;

const Text = styled.p`
  font-size: 14px;
  margin-bottom: 8px;
  font-weight: bold;
`;

const StyledBlankButton = styled.button`
  border: none;
  background: none;
  font-size: ${({ fSize }) => fSize}px;
  margin-top: ${props => (props.block ? '10px' : '')};
  color: ${({ disabled }) => (disabled ? '#CACACA' : '#278C7E')};
  padding: 0;
`;

const ExpiresInMessage = styled.div`
  color: #cacaca;
  font-size: 12px;
`;

const ChangeMobilePhoneLink = styled.a`
  height: 19px;
  width: 182px;
  color: #278c7e;
  font-size: 12px;
  line-height: 19px;
  cursor: pointer;
  &:hover {
    text-decoration: none;
  }
`;

type PropsTypes = {
  placeholder: string,
  showButton: boolean,
  textButton?: string,
  timmerRun?: any,
  disabledButtonCode?: Function,
  handleChangeTimmer?: Function,
  sendWhatsappVerification: (code: string) => void,
  updateMobileNumber: (code: string, mobilePhone: string) => void,
  sendWhatsappCode?: Function,
  canSendWhatsappCode: boolean,
  allowChangeMobilePhone?: boolean,
  phoneValue?: string,
  phoneCountryCode?: string,
  currentUserId?: string
};

const WhatsappVerification = ({
  placeholder,
  showButton,
  textButton,
  sendWhatsappVerification,
  sendWhatsappCode,
  canSendWhatsappCode,
  allowChangeMobilePhone,
  phoneValue,
  phoneCountryCode,
  currentUserId,
  updateMobileNumber
}: PropsTypes) => {
  const [isVisible, setIsVisible] = useState(false);
  return (
    <Wrapper>
      <WrapperContent justifyContent="center">
        <Text>Escribe el código para confirmar tu número de teléfono</Text>
        <WhatsappVerificationCode
          sendWhatsappVerification={sendWhatsappVerification}
          placeholder={placeholder}
          showButton={showButton}
          textButton={textButton}
          marginBottom="0px 0 15px"
          padding="10px 30px"
          showIconWhatsapp
        />
        {allowChangeMobilePhone && (
          <ChangeMobilePhoneLink onClick={() => setIsVisible(true)}>
            Cambiar mi número de celular
          </ChangeMobilePhoneLink>
        )}
        <div>
          <StyledBlankButton
            block
            fSize={16}
            onClick={sendWhatsappCode}
            disabled={!canSendWhatsappCode}
          >
            Enviar nuevamente
          </StyledBlankButton>
        </div>
        <ExpiresInMessage>
          El código que solicitaste tiene una validez de 24 hrs
        </ExpiresInMessage>
      </WrapperContent>
      <ChangeMobilePhoneModal
        open={isVisible}
        onclose={value => setIsVisible(value)}
        phoneValue={phoneValue}
        phoneCountryCode={phoneCountryCode}
        userId={currentUserId}
        updateData={updateMobileNumber}
      />
    </Wrapper>
  );
};

export default withWhatsappVerification(WhatsappVerification);
